import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiDataList, TuiScrollbar, TuiScrollable, TuiDropdown, TuiButton } from '@taiga-ui/core';
import { TuiMedia } from '@taiga-ui/cdk';
import { SharedModule } from '@src/app/shared';
import { IconModule } from '@src/app/modules/icon';

import { MessageInputModule } from '../components';

import { AttachmentComponent } from './attachment.component';
import { AttachmentPreviewComponent } from './attachment-preview/attachment-preview.component';
import { AttachmentDialogComponent } from './attachment-dialog/attachment-dialog.component';

@NgModule({
  declarations: [AttachmentComponent, AttachmentPreviewComponent, AttachmentDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ...TuiDropdown,
    TuiButton,
    TuiMedia,
    TuiScrollbar,
    TuiScrollable,
    ...TuiDataList,
    SharedModule,
    IconModule,
    MessageInputModule,
  ],
  exports: [AttachmentComponent],
})
export class AttachmentModule {}
